import { render, staticRenderFns } from "./PhysicalGame.vue?vue&type=template&id=73f77727&"
import script from "./PhysicalGame.vue?vue&type=script&lang=js&"
export * from "./PhysicalGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports